import { useEffect, useState } from "react";
import { TextInputProps } from "./textInput.interface";

export default function TextInput({
    onChange,
    onBlur,
    onFocus,
    value,
    label,
    placeholder,
    endContent,
    icon,
    disable,
    error,
    parentClassName,
    autoFocus,
    inputClassName,
    errorClassName,
    onKeyPress,
    readonly,
    maxLength,
    dir
}: TextInputProps): JSX.Element {
    const [inputValue, setInputValue] = useState<any>(value ? value : "");

    useEffect(() => {
        if (onChange) onChange(inputValue);
    }, [inputValue]);

    useEffect(() => {
        setInputValue(value);
    }, []);

    useEffect(() => {
        if (inputValue !== value) setInputValue(value);
    }, [value]);

    const onChangeHandler = (e: any) => setInputValue(e.target.value);

    const onBlurHandler = () => onBlur && onBlur(inputValue);

    return (
        <div className={`relative ${parentClassName}`}>
            {label && <label className={`myDark mb-2 block text-[14px] ${disable && "text-gray-300"}`}>{label}</label>}
            <div className="h-[45px] z-0 group relative flex items-center">
                {icon && <span className={`stroke-[#A0A3BD] ${disable && "stroke-gray-300"} absolute right-4`}>{icon}</span>}
                <input
                    dir={dir || "auto"}
                    type="text"
                    className={`outline-none rounded-[10px] transition-all flex items-center pt-[2px] text-[14px] last-of-type:bg-[#EFF0F6] h-full w-full px-4 text-secondary-800 border-[1.5px] border-solid placeholder:text-right placeholder:text-secondary-400 focus:bg-white focus:outline-none focus:border-primary-600 hover:border-secondary-300 ${inputValue?.length > 0 && "!bg-white border-secondary-300"} ${error && "border-red-500"} ${icon && "!pr-[50px]"} ${endContent && "!pl-[50px]"} ${inputClassName}`}
                    value={inputValue}
                    maxLength={maxLength}
                    onChange={onChangeHandler}
                    onBlur={onBlurHandler}
                    onFocus={onFocus}
                    placeholder={placeholder}
                    disabled={disable}
                    autoFocus={autoFocus}
                    onKeyPress={(e) => {
                        if (onKeyPress) onKeyPress(e);
                    }}
                    readOnly={readonly}
                />
                <div className="absolute left-0">{endContent}</div>
            </div>
            {error && <div className={`text-[14px] mt-2 text-red-500 ${errorClassName}`}>{error}</div>}
        </div>
    );
}
